import React from 'react';
import './ToggleSettings.css';

const ToggleSettings = ({visible, toggleSetting}) => {
    if(!visible) return null;

    return (
        <button
            className="b-button b-toggle-settings"
            onClick={() => toggleSetting()}
        >
            <i className="fas fa-cogs"></i>
        </button>
    );
};

export default ToggleSettings;
